import type { I18nKey } from './cs';

/** English dictionary (phase 14) – same keys as `cs.ts`; plural forms `one|few|many`. */
export const en: Record<I18nKey, string> = {
  'nav.home': 'Overview',
  'nav.documents': 'Documents',
  'nav.new': 'New document',
  'nav.payments': 'Payments',
  'nav.stock': 'Stock',
  'nav.jobs': 'Jobs & repairs',
  'nav.assistant': 'Assistant',
  'nav.calendar': 'Calendar',
  'nav.tasks': 'AI tasks',
  'nav.ads': 'Ads',
  'nav.web': 'Websites',
  'nav.wholesale': 'Wholesale',
  'nav.reports': 'Reports',
  'nav.contacts': 'Contacts',
  'nav.accountant': 'Accountant',
  'nav.companies': 'My companies',
  'nav.series': 'Number series',
  'nav.pohoda': 'POHODA',
  'nav.more': 'More',
  'nav.guides': 'Guides',
  'nav.search': 'Search…',
  'nav.notifications': 'Notifications',
  'nav.logout': 'Sign out',
  'nav.shortcuts': 'Keyboard shortcuts',
  'nav.shortcuts.search': 'search and actions',
  'nav.shortcuts.new': 'new invoice',
  'nav.shortcuts.help': 'this help',
  'nav.account': 'Account',
  'nav.admin': 'Administration',

  'common.save': 'Save',
  'common.cancel': 'Cancel',
  'common.close': 'Close',
  'common.delete': 'Delete',
  'common.edit': 'Edit',
  'common.back': 'Back',
  'common.open': 'Open',
  'common.loading': 'Loading…',
  'common.nothing': 'Nothing here.',
  'common.all': 'All',
  'common.language': 'Language',
  'common.yes': 'Yes',
  'common.no': 'No',

  'home.newInvoice': 'New invoice',
  'home.stock': 'Stock',
  'home.todo': 'To do',
  'home.payables': 'Payables',
  'home.customize': 'Customize',
  'home.customSelection': 'custom selection',
  'home.resetRole': 'Reset to role default',

  'documents.title': 'Documents',
  'documents.selectAll': 'Select all',
  'documents.cancelSelection': 'Cancel selection',
  'documents.markSent': 'Mark as sent',
  'documents.csv': 'CSV',
  'documents.csvSelection': 'CSV of selection',
  'documents.empty': 'No documents yet.',

  'doc.issue': 'Issue',
  'doc.edit': 'Edit',
  'doc.deleteDraft': 'Delete draft',
  'doc.pdf': 'Download PDF',
  'doc.preview': 'Preview',
  'doc.sendEmail': 'Send by e-mail',
  'doc.markSent': 'Mark as sent',
  'doc.remind': 'Send reminder',
  'doc.items': 'Items',
  'doc.payments': 'Payments',
  'doc.emails': 'E-mails',
  'doc.archive': 'Archive',
  'doc.internalNote': 'Internal note',
  'doc.note': 'Note',
  'doc.language': 'Document language',
  'doc.language.cs': 'Czech',
  'doc.language.en': 'English',
  'doc.language.cs-en': 'bilingual (cs / en)',
  'doc.language.sk': 'Slovak',
  'doc.language.de': 'German',
  'doc.language.pl': 'Polish',
  'doc.language.auto': 'by partner',
  'doc.new': 'New document',
  'doc.draft': 'Draft',
  'doc.customer': 'Customer',
  'doc.supplier': 'Supplier',
  'doc.dates': 'Date',
  'doc.terms': 'Terms and payment',

  'payments.title': 'Payments',
  'stock.title': 'Stock',
  'stock.units': 'Units by IMEI',
  'stock.products': 'Products',
  'stock.movements': 'Movements',
  'stock.receive': 'Receive',
  'stock.addProduct': 'Add product',
  'stock.stocktake': 'Stocktake',
  'stock.scanner': 'Scanner',
  'contacts.title': 'Contacts',
  'contacts.addAres': 'Add from ARES',
  'contacts.addManual': 'Add manually',

  'more.title': 'More',
  'more.account': 'Account',

  'account.title': 'Account',
  'account.signedInAs': 'Signed in as',
  'account.changePassword': 'Change password',
  'account.devices': 'Signed-in devices',
  'account.loginHistory': 'Login history',
  'account.language': 'App language',
  'account.language.hint': 'Applies on this device and after signing in elsewhere.',
  'account.app': 'App',

  'login.title': 'Sign in',
  'login.register': 'New account',
  'login.email': 'E-mail',
  'login.password': 'Password',
  'login.submit': 'Sign in',
  'login.create': 'Create account',
  'login.haveAccount': 'I already have an account',
  'login.hint':
    'iSupply Invoices. One account owns all invoicing companies; add them in My companies.',
  'login.mfa.title': 'Second step',
  'login.mfa.code': 'Code from your authenticator or a recovery code',
  'login.mfa.back': 'Back to password',
  'login.mfa.hint':
    'The code changes every 30 s. Without your phone, use one of the recovery codes.',

  'notifications.title': 'Notifications',
  'notifications.markAll': 'Mark all as read',
  'notifications.empty': 'No notifications yet.',
  'approvals.title': 'Approvals',
  'approvals.pending': 'Pending',
  'approvals.history': 'History',
  'approvals.approve': 'Approve',
  'approvals.reject': 'Reject',

  'row.pay': 'Pay',
  'row.pdf': 'PDF',
  'row.matchPayment': 'Match payment',
  'row.overpaid': 'Resolve overpayment',
  'row.split': 'Split payment',
  'row.openDocument': 'Open document',
  'export.failed': 'Export failed',
  'comments.title': 'Internal comments',
  'comments.edited': 'edited',
  'common.loadMore': 'Load more',
  'plural.unread': '{n} unread|{n} unread|{n} unread',
  'plural.documents': '{n} document|{n} documents|{n} documents',
  'plural.items': '{n} item|{n} items|{n} items',
};
